import { render, staticRenderFns } from "./review-list.vue?vue&type=template&id=0a204e5e&"
import script from "./review-list.vue?vue&type=script&lang=ts&"
export * from "./review-list.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports